<template>
    <div class="d-none">
        <div :id="modal_id" class="modal-box">
            <div v-if="bannerImage" :class="getBannerImageClass" :style="{ backgroundImage: 'url(' + bannerImage + ')',backgroundSize:'contain' }"> </div>
            <div class="close-button"> <a href="javascript:;" class="modal-close white"></a> </div>
            <div class="modal-container padding0">
                <div class="modal-banner">
                    <div class="featured" :style='{paddingTop:getFeaturedPadding}'>
                        <span class="img-name" :style="{ backgroundImage: 'url(' + image + ')' ,backgroundSize:'contain'}"></span>
                    </div>
                </div>
                <article class="content-article no-shadow">
                    <div v-if="this.offer && this.offer.OfferId" class="article-info">
                        <p class="big txt-black">{{ this.offer.OfferProvider == 'pclo' ? this.offer.ShortDescription : this.offer.Headline}}</p>
                        <div class="expires black" v-if="isNaN(this.offer.EventEndDate)">{{ 'Expires - ' + formattedEndDate }} </div>
                        <div class="expires" v-show="!isNaN(this.offer.EventEndDate)">Expires
                            <span v-if="this.offer.EventEndDate == 1">today</span>
                            <span v-if="this.offer.EventEndDate != 1">
                            {{ 'in ' + this.offer.EventEndDate }}
                        <span v-if="this.offer.EventEndDate > 1">days</span>
                        <span v-if="this.offer.EventEndDate == 1">day</span>
                    </span>
                        </div>
<!--                        <div class="">-->
<!--                            <a href="javascript:;" @click="showEnrollCard" class="button pink midsize mid my-3">Register</a>-->
<!--                        </div>-->
                        <div v-if="this.offer.ActiveSc == 'AVAILABLE' && !this.activatedNow">
<!--                            <a @click="showEnrollCard" class="button pink tinysize small mTop10 modal-link">Activate</a>-->
                            <a @click="activateOrShowEnrollCard" :disabled="activating" :class="(activating || show_offer_activation_failed_msg) ? 'button pink tinysize small mTop10 modal-link isDisabled' : 'button pink tinysize small mTop10 modal-link'">{{this.activating ? 'Activating' : 'Activate' }}</a>
                            <p class="offerActivationFailedMsg"  style="font-size: 1vw"   v-if="show_offer_activation_failed_msg"> Offer Activation Failed</p>
                        </div>
                        <div v-if="this.offer.ActiveSc != 'AVAILABLE' || this.activatedNow">
                            <a href="javascript:" class="button pink activated tinysize small mTop10 modal-link">Activated</a>
                        </div>
                    </div>
                </article>
                <div v-if="this.offer && this.offer.OfferId"  class="modal-info">
                    <h5 v-if="this.offer.LongDescription" class="heading__h5 text-center">Offer Details</h5>

                    <p v-if="this.offer.LongDescription">{{this.offer.LongDescription}}</p>

                    <h5 v-if="this.offer.DetailedTerms || this.offer.LongTerms" class="heading__h5 text-center">Offer Terms & Conditions</h5>
                    <p v-if="this.offer.DetailedTerms">{{this.offer.DetailedTerms}}</p>
                    <p v-if="this.offer.LongTerms">{{this.offer.LongTerms}}</p>

<!--                    <div class="button-container text-center">-->
<!--                        <a href="javascript:;" class="button fs-4 txt-black">View full terms &amp; conditions</a>-->
<!--                    </div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
export default {
  components: { },
    props: ['offer', 'activatedNow', 'show_offer_activation_failed_msg'],
    name: 'OfferDetailsComponent',
    data(){
        return {
            modal_id: (this.offer && this.offer.OfferId) ? 'offer-details-modal-'+this.offer.OfferId : 'offer-details-modal-'+_.random(1, 10000000) + _.random(1, 10000000),
            image: this.offer && this.offer.hasOwnProperty('MerchantImageURL') ? this.offer.MerchantImageURL : '../images/placeholder.jpg',
            bannerImage: this.offer && this.offer.hasOwnProperty('MerchantHeaderImageURL') ? this.offer.MerchantHeaderImageURL : null,
            activating:false
        }
    },
    methods : {
        reload(user) {
            this.$emit('reload', user)
        },
        reloadOffer(offer) {
            this.$emit('reloadOffer', offer)
        },
        activateOrShowEnrollCard() {
            this.activating = true;
            this.$emit('showEnrollCardOrActivate');
        },
    },
    computed: {
        formattedEndDate() {
            return (this.offer && this.offer.EventEndDate) ? moment(this.offer.EventEndDate).format('MM-DD-YYYY') : '';
        },
        getFeaturedPadding() {
            let ret = '10%';

            if(this.bannerImage) {
                if(this.offer && this.offer.OfferProvider == 'pclo' ) {
                    ret =  '15%';
                } else {
                    ret =  '30%';
                }
            }

            return ret;
        },
         getBannerImageClass() {
            let ret = 'lifeStyleBackGroundImage';
            if(this.offer && this.offer.OfferProvider == 'pclo' ) {
                ret =  'lifeStyleBackGroundImagePclo';
            }
            return ret;
        }
    },
    watch: {
        activatedNow: function (val) {
            this.activating = false;
        },
        show_offer_activation_failed_msg: function (val) {
            if(val) {
                this.activating = false;
            }
        }
    },
    mounted: function() {
        $('.modal-close').on('click', function (e) {
            e.preventDefault();
            $.colorbox.close();
        });
    }
}
</script>

<style scoped>
    .isDisabled {
        pointer-events: none;
    }
    .offerActivationFailedMsg{
        color: #eb2d2e;
        font-size: 1vw;
        padding: 0.5vw 0.5vw 0.5vw 0;
    }

    .lifeStyleBackGroundImage{
        position: absolute;
        left: 0;
        right: 0;
        width:100%;
        height:35%;
        z-index: 1;
        background-size: cover;
        background-repeat: no-repeat;
    }
     .lifeStyleBackGroundImagePclo{
        position: absolute;
        left: 0;
        right: 0;
        width:100%;
        height:200px;
        z-index: 1;
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    @media (max-width: 760px) {
        .lifeStyleBackGroundImagePclo {
            height: 165px; /* Adjust the height for smaller screens */
        }
    }

</style>
